export const baseApi = 'https://cabinet.tes.trade/admin'
